import { render, staticRenderFns } from "./SelectTicketsAmount.vue?vue&type=template&id=04de916c&scoped=true&"
import script from "./SelectTicketsAmount.vue?vue&type=script&lang=js&"
export * from "./SelectTicketsAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04de916c",
  null
  
)

export default component.exports